import { ColDef, ITooltipParams } from 'ag-grid-enterprise';
import { FundDocument } from '~/api/def/endpoints/fundEndpoint';
import { ExtractionStatusCellAg } from '~/components/ui/tables/ag/cellRenderers/ExtractionStatusCellAg';
import { InvestorCellAg } from '~/components/ui/tables/ag/cellRenderers/InvestorCellAg';
import { LivenessTagCellAg } from '~/components/ui/tables/ag/cellRenderers/LivenessTagCellAg';
import { RestatedTagCellAg } from '~/components/ui/tables/ag/cellRenderers/RestatedTagCellAg';
import { OpenDocumentOverviewCell } from '~/components/ui/tables/ag/documentsTable/OpenDocumentOverviewCell';
import { SourceCellAg } from '../cellRenderers/SourceCellAg';
import { format } from 'date-fns';

export const getColDefsDocumentTable = (callbacks: {
  showDocumentOverview: (documentId: string) => void;
}): ColDef<FundDocument>[] => [
  {
    field: 'extractionStatus',
    headerName: '',
    sortable: false,
    filter: false,
    // type: "w50",
    maxWidth: 50,
    suppressHeaderMenuButton: true,
    resizable: true,
    cellRenderer: ExtractionStatusCellAg,
    tooltipValueGetter: (p: ITooltipParams) => {
      switch (p.value) {
        case null:
          return 'Extraction not started';
        case 'fail':
          return 'Extraction Error';
        case 'pending':
          return 'Pending';
        case 'success':
          return 'Extraction Complete';
        case 'started':
          return 'Extraction Running';
      }
    },
  },
  {
    field: 'originalName',
    headerName: 'Name',
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    cellClass: 'flex align-items-center',
    cellRenderer: (p: { value: string; data: FundDocument }) =>
      OpenDocumentOverviewCell({
        ...p,
        showDocumentOverview: callbacks.showDocumentOverview,
      }),
    tooltipValueGetter: (p: ITooltipParams) => p.value,
  },
  {
    field: 'type',
    headerName: 'Agreement Type',
    sortable: true,
    filter: true,
    resizable: true,
    tooltipField: 'type',
    tooltipValueGetter: (p: ITooltipParams) => p.value,
    cellClass: 'flex align-items-center',
  },
  {
    field: 'liveness',
    cellRenderer: LivenessTagCellAg,
    suppressHeaderMenuButton: true,
    headerName: 'Status',
    maxWidth: 120,
    sortable: true,
    resizable: true,
    cellClass: 'flex align-items-center justify-content-center',
    filter: true,
    // type: "w120",
  },
  {
    field: 'restated',
    headerName: 'Restated',
    sortable: true,
    filter: true,
    maxWidth: 120,
    resizable: true,
    cellClass: 'flex align-items-center justify-content-center',
    suppressHeaderMenuButton: true,
    cellRenderer: RestatedTagCellAg,
  },
  {
    field: 'investorName',
    headerName: 'Investor',
    cellClass: 'flex align-items-center justify-content-center',
    sortable: true,
    filter: true,
    resizable: true,
    tooltipField: 'investorName',
    cellRenderer: InvestorCellAg,
  },
  {
    field: 'admissionDate',
    filter: 'agDateColumnFilter',
    headerName: 'Admission Date',
    cellClass: 'flex align-items-center',
    sortable: true,
    resizable: true,
    flex: 1,
    valueFormatter: (p) => (p.value ? format(p.value, 'yyyy-MM-dd') : '-'),
  },
  {
    field: 'source',
    headerName: 'Source',
    filter: true,
    cellClass: 'flex align-items-center justify-content-center',
    sortable: true,
    resizable: true,
    cellRenderer: SourceCellAg,
  },
  {
    field: 'createdAt',
    filter: 'agDateColumnFilter',
    headerName: 'Created At',
    cellClass: 'flex align-items-center',
    sortable: true,
    resizable: true,
    flex: 1,
  },
];
